export const PLANK_IS_SHOWN = 'PLANK_IS_SHOWN';
export const PLANK_IS_HIDDEN = 'PLANK_IS_HIDDEN';
export const PLANK_MOBILE_LINK_AND_TYPE = 'PLANK_MOBILE_LINK_AND_TYPE';
